import { IconProps } from "./icon.type";

export function IcSearch(props: IconProps) {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.5569 44.3208C44.3736 43.4962 45.6977 43.4962 46.5144 44.3208L54.2874 52.1682C55.1041 52.9928 55.1041 54.3296 54.2874 55.1542C53.4707 55.9787 52.1465 55.9787 51.3298 55.1542L43.5569 47.3067C42.7402 46.4821 42.7402 45.1453 43.5569 44.3208Z"
        fill="#B2BBC4"
      />
      <path
        d="M28.8307 51.421C41.2094 51.421 51.2443 41.2899 51.2443 28.7924C51.2443 16.295 41.2094 6.16385 28.8307 6.16385C16.4519 6.16385 6.41699 16.295 6.41699 28.7924C6.41699 41.2899 16.4519 51.421 28.8307 51.421Z"
        fill="#EDF3FA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.8319 8.10046C17.5125 8.10046 8.33641 17.3646 8.33641 28.7924C8.33641 40.2203 17.5125 49.4844 28.8319 49.4844C40.1512 49.4844 49.3273 40.2203 49.3273 28.7924C49.3273 17.3646 40.1512 8.10046 28.8319 8.10046ZM4.5 28.7924C4.5 15.2255 15.3938 4.22726 28.8319 4.22726C42.27 4.22726 53.1638 15.2255 53.1638 28.7924C53.1638 42.3594 42.27 53.3576 28.8319 53.3576C15.3938 53.3576 4.5 42.3594 4.5 28.7924Z"
        fill="#B2BBC4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.0054 28.8512C38.0054 33.934 33.925 38.0536 28.8904 38.0536C23.8558 38.0536 19.7754 33.934 19.7754 28.8512C19.7754 26.4098 20.7358 24.0694 22.4449 22.3429C24.1541 20.6174 26.4732 19.6477 28.8904 19.6477C33.925 19.6477 38.0054 23.7673 38.0054 28.8501V28.8512Z"
        fill="#B2BBC4"
      />
      <path
        d="M26.9992 28.647C28.6907 28.647 30.0619 27.2626 30.0619 25.555C30.0619 23.8473 28.6907 22.4629 26.9992 22.4629C25.3077 22.4629 23.9365 23.8473 23.9365 25.555C23.9365 27.2626 25.3077 28.647 26.9992 28.647Z"
        fill="white"
      />
    </svg>
  );
}
